import { ComplianceRepository } from "../../repositories/ComplianceRepository";

export class DeleteComplianceTypeUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(id: number): Promise<void> {
    if (!id) {
      throw new Error("Compliance type ID is required");
    }

    return await this.repository.deleteComplianceType(id);
  }
}

